
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started/global-contractor",
      function () {
        return require("private-next-pages/get-started/global-contractor.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-started/global-contractor"])
      });
    }
  